
export const DCSelector = ({ selectedType, onTypeSelected }) => {

    const debit = { type: "debit", icon: "fa-minus" };
    const credit = { type: "credit", icon: "fa-plus" };

    const DCs = [
        debit,
       credit,
    ];

    const convertDC = () => DCs.find(r => r.type === selectedType);

    return (

        <div className="mb-3 d-md-flex fw-bold">
            <div className="dropdown-toggle">
                <div style={{ cursor: "pointer" }} data-bs-toggle="dropdown" className="text-decoration-none text-dark capitalize"><div className="text-capitalize" ><i className={`fa ${(convertDC() ?? debit).icon} fa-fw text-dark text-opacity-50 me-1`}></i>{(convertDC() ?? debit).type} <b className="ms-5px caret"></b></div> </div>
                <div className="dropdown-menu dropdown-menu-start">
                    {DCs.map((dc, i) => ( // For each type...
                        <div onClick={() => onTypeSelected(dc.type)} style={{ cursor: "pointer" }} key={i} className="dropdown-item capitalize"><div className="text-capitalize"><i className={`fa ${dc.icon} fa-fw fa-lg text-gray-500 me-1`}></i>{dc.type}</div> </div>
                    ))}
                </div>
            </div>
        </div>
    );
};